import {
  Component,
  Input,
  ViewEncapsulation,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  GridHeader,
  GridValue,
  LineItemMonitorMeta,
} from "../line-item-monitor.model";
import { AppService } from "src/app/app.service";
import {
  VAIconRegistryService,
  chartBar,
  chevronDown,
  chevronUp,
} from "@va/core-library/icons";
/**
 * Not using ant-grid-custom component for grid because it has filters functionality in sub-header,
 * whereas this grid is simple layout of data without any other functionality
 *
 * */
@Component({
  selector: "app-line-item-monitor-grid",
  templateUrl: "./line-item-monitor-grid.component.html",
  host: { class: "line-item-monitor-grid" },
  styleUrls: ["./line-item-monitor-grid.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class LineItemMonitorGridComponent {
  @Input() gridHeader: GridHeader;
  @Input() gridValues: Array<GridValue>;
  @Input() isLoading: boolean;
  @Input() widthConfig: Array<string>;
  @Output() onPeriodUpdate: EventEmitter<any> = new EventEmitter();
  @Input() lineItemsMeta: LineItemMonitorMeta;
  @Input() tabName: string;
  @Input() ticker: string;

  chartPopupDataToUse: any = {};
  companyFullName = "";
  chartPopupType = "";
  chartPopupVisible = false;
  beginningStateReferrer = "LINE_ITEM_MONITOR";
  feature = "LINE_ITEM_MONITOR";
  chartType: string;
  relativePeriods: Array<string>;
  showPopover = false;
  showPopovers = [];
  selectedLineItem;

  constructor(
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([chartBar, chevronDown, chevronUp]);
  }

  ngOnInit() {
    this.relativePeriods = this.lineItemsMeta.relative_periods;
    this.chartType = this.tabName;
    this.showPopovers = Array(this.gridHeader.level1.length - 1).fill(false);
  }

  onPeriodChange(periodIndex, value, selectedPeriod) {
    if (value !== undefined)
      this.onPeriodUpdate.emit([periodIndex, value, selectedPeriod]);
    this.showPopovers[periodIndex] = false;
  }

  showChartPopup(data, chartType) {
    this.chartPopupDataToUse = {
      companyFullName: this.lineItemsMeta.companyname,
      period: this.lineItemsMeta.chart_estimated_period,
      source: "Consensus",
      forecast: true,
      cut: "NMV",
      isPeers: false,
      gAdjust: "implied",
      dapparamId: data.id,
      ticker: this.ticker,
      export: true,
      currentQuarter: this.lineItemsMeta.current_quarter,
    };
    this.chartPopupType = chartType;
    this.chartPopupVisible = true;
  }

  selectLineItem(data) {
    this.selectedLineItem = data.id;
  }
  hideChartPopup() {
    this.chartPopupVisible = false;
  }
}
